// extracted by mini-css-extract-plugin
module.exports = {"container":"Fax_container__3WXhA"};